import { PartialTheme, Theme } from '@fluentui/react';
import { IThemeExtensions } from './IThemeExtensions';

//theme used at runtime
export type BaseTheme = Theme & IThemeExtensions;

type ThemeObject = Record<keyof Theme, undefined>;
const themeObjectProperties: ThemeObject = {
    components: undefined,
    name: undefined,
    id: undefined,
    schemes: undefined,
    rtl: undefined,
    palette: undefined,
    fonts: undefined,
    semanticColors: undefined,
    isInverted: undefined,
    disableGlobalClassNames: undefined,
    spacing: undefined,
    effects: undefined,
};
export const ALL_FLUENT_THEME_PROPERTIES = Object.keys(themeObjectProperties);

//theme settings provided to configure theme
export type BaseThemeSettings = PartialTheme & IThemeExtensions;
